import React from "react";

import AccountDeletionPage from "@/pages/Deletion/AccountDeletionPage";

export default function Layout(): React.JSX.Element {
  return <AccountDeletionPage />;
}
